import { createResource } from 'solid-js'
import { trpc } from '../trpc.ts'

/* resolved once at startup: the app either renders or shows the login page, so
   there's nothing to react to until the user navigates away to the oidc flow */
export const [authMe, { refetch: refetchAuthMe }] = createResource(() => trpc.auth.me.query())

export const isAdmin = () => authMe()?.role === 'admin'

/** browsing anonymously, with access to whatever indexes were opened to guests */
export const isGuest = () => authMe()?.guest === true
